document.addEventListener("DOMContentLoaded", function () {
  const menuToggle = document.querySelector(".header__mobile-menu-toggle");
  const topLevelMenu = document.querySelector("#mobile-navigation");

  const ACTIVE = "active";
  const NO_SCROLL = "no-scroll";

  // toggle menu
  menuToggle.addEventListener("click", function () {
    if (topLevelMenu.classList.contains(ACTIVE)) {
      closeMobileMenu();
    } else {
      topLevelMenu.classList.add(ACTIVE);
      this.classList.add(ACTIVE);

      const body = document.body;
      if (!body.classList.contains(NO_SCROLL)) {
        body.classList.add(NO_SCROLL);
      }

      if (body.classList.contains("search-active")) {
        body.classList.remove("search-active");
      }
    }
  });

  const menuItemWithChildren = document.querySelectorAll(
    ".mobile-menu__link.has-children"
  );

  // handle opening child menus
  if (menuItemWithChildren && menuItemWithChildren.length) {
    menuItemWithChildren.forEach(function (menuItem) {
      menuItem.addEventListener("click", function (e) {
        e.preventDefault();

        const childMenu = menuItem.parentNode.querySelector(
          ".mobile-menu__wrapper"
        );
        childMenu.classList.add("active");
      });
    });
  }

  const previousMenuButtons = document.querySelectorAll(
    ".mobile-menu__previous-menu-button"
  );

  // handle click on previous menu button
  if (previousMenuButtons && previousMenuButtons.length) {
    previousMenuButtons.forEach(function (previousMenuButton) {
      // TODO: does click cover everything?
      previousMenuButton.addEventListener("click", function (e) {
        // TODO: better way to handle this
        previousMenuButton.parentNode.parentNode.classList.remove(ACTIVE);
      });
    });
  }

  const menuOverlay = document.querySelector(".menu__overlay");

  menuOverlay.addEventListener("click", function (e) {
    closeMobileMenu();
    document.body.classList.remove(NO_SCROLL);
    menuToggle.classList.remove(ACTIVE);

    // styles for search too
    // TODO: move these?
    if (document.body.classList.contains("search-active"))
      document.body.classList.remove("search-active");
  });

  function closeMobileMenu() {
    menuToggle.classList.remove(ACTIVE);

    const body = document.body;
    if (body.classList.contains(NO_SCROLL)) {
      body.classList.remove(NO_SCROLL);
    }

    const activeMenus = document.querySelectorAll(
      ".mobile-menu__wrapper.active"
    );
    activeMenus.forEach(function (activeMenu) {
      activeMenu.classList.remove(ACTIVE);
    });
  }
});
